import React from "react";
const Heading=(props)=>{
return(
    <section>
    <h1>{props.heading}</h1>
  </section>
)
}
export default Heading